
import { useState } from 'react';
import { useEventData } from './hooks/useEventData';
import { useFormWatchers } from './hooks/useFormWatchers';
import { EventFormValues } from '../schemas/eventFormSchema';

interface UseEventEditorProps {
  eventId: string | null;
  open: boolean;
  onClose: () => void;
  onFormChanged?: (isDirty: boolean) => void;
}

export const useEventEditor = ({ eventId, open, onClose, onFormChanged }: UseEventEditorProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Get form and event data
  const { isLoading, form, resetForm } = useEventData({ 
    eventId, 
    open, 
    onClose 
  });

  // Setup form watchers
  useFormWatchers({ 
    form, 
    onFormChanged 
  });

  return {
    isLoading,
    isSubmitting,
    setIsSubmitting,
    form,
    resetForm,
  };
};
